import type { TNamespace, INamespaceConfig } from './types';
import { ingleConfig } from './namespaces/ingle';
import { tisConfig } from './namespaces/tis';

const namespace = import.meta.env.VITE_NAMESPACE as TNamespace;

const configs: Record<TNamespace, INamespaceConfig> = {
  ingle: ingleConfig,
  tis: tisConfig,
};

export const activeConfig: INamespaceConfig = configs[namespace] ?? ingleConfig;

export { ConfigProvider } from './ConfigProvider';
export { useConfig } from './useConfig';
export type { INamespaceConfig, TNamespace } from './types';
